<template>
  <div class="login-conatiner">
    <van-icon
      name="arrow-left"
      v-if="!$store.state.wxProgram"
      class="login-conatiner-back"
      @click="back"
    />
    <div class="login-content" v-if="$store.state.isPad">
      <div class="phone-login" v-if="pageIndex == 0">
        <i class="close" @click="$store.commit('changeLoginShow', false)"></i>
        <span class="title">手机号登录</span>
        <span class="tip"
          >同一手机号登录社区、游戏官方服，将自动同步社区数据</span
        >
        <div class="input-box input-box1">
          <i class="phone-num">+86</i>
          <input
            type="text"
            placeholder="输入手机号"
            maxlength="11"
            v-model="form.account"
          />
        </div>
        <div class="input-box input-box2">
          <input
            type="text"
            placeholder="输入验证码"
            maxlength="6"
            v-model="code"
          />
          <span
            class="input-box2-span"
            style="cursor: pointer"
            @click="sendMessage"
            v-if="waitTime == 0"
            >获取验证码</span
          >
          <span style="color: #cccccc" v-else>{{ waitTime }}s后重新获取</span>
        </div>
        <i class="login-btn" @click="login"
          ><span v-if="!loading">登录</span>
          <i v-else class="loading"></i>
        </i>
        <div ref="agree" class="bottom-agree">
          <i
            :class="isAgree ? 'select-on' : 'select-icon'"
            @click="isAgree = !isAgree"
          ></i>
          <span style="color: #969696" @click="isAgree = !isAgree"
            >阅读并同意</span
          >
          <a
            href="https://www.zlongame.com/html/legaldoc/community.html"
            target="_blank"
            ><span style="color: #23323d">《用户协议》</span></a
          >
          <a
            v-show="$store.state.gameType == 1"
            href="https://www.zlongame.com/html/legaldoc/1504685273578/privacy.html"
            target="_blank"
            ><span style="color: #23323d"> 《隐私政策》</span></a
          >
          <a
            v-show="$store.state.gameType == 2"
            href="https://www.zlongame.com/html/legaldoc/1705460260139/privacy.html"
            target="_blank"
            ><span style="color: #23323d"> 《隐私政策》</span></a
          >
          <a
            v-show="$store.state.gameType == 3"
            href="http://www.zlongame.com/html/login/privacy.html"
            target="_blank"
            ><span style="color: #23323d"> 《隐私政策》</span></a
          >
        </div>
      </div>
      <div class="game-info" v-if="pageIndex == 1">
        <i class="close" @click="closeBindInfo"></i>
        <span class="title">绑定游戏信息 </span>
        <span class="tip"
          >首次登录社区，您可以绑定游戏信息，同步游 戏内社区数据。
        </span>
        <div class="tip-2" @click="getCodeShow = true">
          <span>请打开 游戏App-社区-我的-绑定码 获取 </span>
          <i class="help-icon"></i>
        </div>
        <input type="text" v-model="bindNum" placeholder="输入绑定码" />
        <i class="submit-game" @click="getBind">确定</i>
        <span class="bottom-tip" @click="closeBindInfo">以后再说 </span>
      </div>
      <div class="choose-box" v-if="pageIndex == 2">
        <i class="close" @click="closeChoose"></i>
        <span class="title">请选择要登录的社区账号 </span>
        <span class="tip">该手机号下有两个社区账号，需要选择一个登录 </span>
        <div class="user-box" v-if="userArr.length != 0">
          <div
            :class="`user ${
              selectOnAcc.memberId == item.memberId ? 'user-on' : ''
            }`"
            v-for="item in userArr"
            :key="item.id"
            @click="chooseAccount(item)"
          >
            <img class="avatar" :src="item.avatar" />
            <span class="name">{{ item.nickName }}</span>
          </div>
        </div>
        <i class="choose-btn" @click="confirmAcc">确定</i>
      </div>
      <div class="tip-model" v-if="pageIndex == 3">
        <i class="close" @click="closeTip"></i>
        <span class="title" :style="tipNum == 0 ? 'margin-bottom:.7rem' : ''"
          >提示</span
        >
        <div v-if="tipNum == 0">
          请先<span
            style="color: #2e7bff; cursor: pointer"
            @click="getTip(0, null)"
            >登录</span
          >后，在进行操作
        </div>
        <!-- <span v-if="false"
          >您下载游戏后，可以在社区「我的」-「设置」 -「换绑账号」绑定游戏信息。
        </span> -->
        <span v-if="tipNum == 1">手机号格式错误</span>
        <span v-if="tipNum == 2">验证码错误</span>
        <span v-if="tipNum == 3">绑定码不存在或错误</span>
        <span v-if="tipNum == 4">该绑定码已经绑定，不能二次绑定</span>
        <i class="close-tip" v-if="tipNum != 0" @click="closeTip">确定</i>
      </div>
    </div>
    <div class="login-mo" v-else>
      <i class="logo" v-show="isShow" style="margin-bottom: 2.4rem"></i>
      <!-- <i class="logo" style="margin-bottom: 2.4rem"></i> -->
      <span>同一手机号登录社区、游戏官方服，将自动同步社区数据 </span>
      <div class="input-box input-box1">
        <i class="phone-num">+86</i>
        <input
          type="text"
          placeholder="输入手机号"
          maxlength="11"
          v-model="form.account"
        />
      </div>
      <div class="input-box input-box2">
        <input
          type="text"
          placeholder="输入验证码"
          maxlength="6"
          v-model="code"
        />
        <span @click="sendMessage" class="input-box2-span" v-if="waitTime == 0"
          >获取验证码</span
        >
        <span style="color: #cccccc" v-else>{{ waitTime }}s后重新获取</span>
      </div>
      <i class="login-btn" @click="login"
        ><span v-if="!loading">登录</span> <i v-else class="loading"></i
      ></i>
      <div ref="agree" class="bottom-agree">
        <i
          :class="isAgree ? 'select-on' : 'select-icon'"
          @click="isAgree = !isAgree"
        ></i>
        <span style="color: #969696">阅读并同意</span>
        <a
          href="https://www.zlongame.com/html/legaldoc/community.html"
          target="_blank"
          ><span style="color: #23323d">《用户协议》</span></a
        >
        <a
          v-show="$store.state.gameType == 1"
          href="https://www.zlongame.com/html/legaldoc/1504685273578/privacy.html"
          target="_blank"
          ><span style="color: #23323d"> 《隐私政策》</span></a
        >
        <a
          v-show="$store.state.gameType == 2"
          href="https://www.zlongame.com/html/legaldoc/1705460260139/privacy.html"
          target="_blank"
          ><span style="color: #23323d"> 《隐私政策》</span></a
        >
        <a
          v-show="$store.state.gameType == 3"
          href="http://www.zlongame.com/html/login/privacy.html"
          target="_blank"
          ><span style="color: #23323d"> 《隐私政策》</span></a
        >
      </div>
      <div class="pop" v-if="pageIndex != 0">
        <div class="choose-box" v-if="pageIndex == 2">
          <i class="close" @click="closeChoose"></i>
          <span class="title">请选择要登录的社区账号 </span>
          <span class="tip">该手机号下有两个社区账号，需要选择一个登录 </span>
          <div class="user-box" v-if="userArr.length != 0">
            <div
              :class="`user ${
                selectOnAcc.memberId == item.memberId ? 'user-on' : ''
              }`"
              v-for="item in userArr"
              :key="item.id"
              @click="chooseAccount(item)"
            >
              <img class="avatar" :src="item.avatar" />
              <span class="name">{{ item.nickName }}</span>
            </div>
          </div>
          <i class="choose-btn" @click="confirmAcc">确定</i>
        </div>
        <div class="game-info" v-if="pageIndex == 1">
          <i class="close" @click="closeBindInfo"></i>
          <span class="title">绑定游戏信息</span>
          <span class="tip"
            >首次登录社区，您可以绑定游戏信息，同步游 戏内社区数据。
          </span>
          <div class="tip-2" @click="getCodeShow = true">
            <span>请打开 游戏App-社区-我的-绑定码 获取 </span>
            <i class="help-icon"></i>
          </div>
          <input type="text" v-model="bindNum" placeholder="输入绑定码" />
          <i class="submit-game" @click="getBind">确定</i>
          <span class="bottom-tip" @click="closeBindInfo">以后再说 </span>
        </div>
        <div class="tip-model" v-if="pageIndex == 3">
          <i class="close" @click="closeTip"></i>
          <span class="title">提示</span>
          <div v-if="tipNum == 0">
            请先<span
              style="color: #2e7bff; cursor: pointer"
              @click="getTip(0, null)"
              >登录</span
            >后，在进行操作
          </div>
          <span v-if="tipNum == 1">手机号格式错误</span>
          <span v-if="tipNum == 2">验证码错误</span>
          <span v-if="tipNum == 3">绑定码不存在或错误</span>
          <span v-if="tipNum == 4">该绑定码已经绑定，不能二次绑定</span>
          <i class="close-tip" @click="closeTip">确定</i>
        </div>
      </div>
    </div>
    <getBindCode v-if="getCodeShow"></getBindCode>
  </div>
</template>

<script>
import * as _code from '../utils/code';
import get from '@/api/get';
import qs from 'qs';
import getBindCode from './login/getBindCode.vue';
import { Toast } from 'vant';
import Cookies from 'js-cookie';
export default {
  components: {
    getBindCode
  },
  data() {
    return {
      loading: false, //登录中
      isShow: true,
      getCodeShow: false,
      bindNum: '', //绑定码
      loginParams: {}, //缓存短信验证账号信息，用于绑定登录
      selectOnAcc: {}, //当前选中账号信息
      isAgree: false,
      waitTime: 0, //短信间隔时间
      tipNum: 0, //0未登录  1手机格式  2验证码  3绑定码 4绑定码已绑
      code: '', //短信验证码
      form: {
        action: 'page',
        method: 'send',
        isMobileLogin: 1,
        account: '',
        sign: '',
        annex: ''
      },
      pageIndex: null, // 0 登录  1绑定游戏信息  2选择账号 3提示
      userArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    closeChoose() {
      this.selectOnAcc = {};
      this.pageIndex = 0;
      this.$store.commit('changeLoginShow', false);
      this.$store.commit('changeLoginStatus', 1); //未选择时，模拟登录状态
      let gameAppkey =
        this.$store.state.gameAppkeyArr[this.$store.state.gameType];
      this.$store.commit('changeToken', Cookies.get(`_pd_auth_${gameAppkey}`)); //未选择时，先把匿名token替换
      get.webLogoff().then((res) => {
        if (res.data.code == 0) {
          this.$store.commit('changeLoginStatus', 0); //退出模拟登录状态
          // 构造当前URL的 URLSearchParams 对象
          const params = new URLSearchParams(window.location.search);
          // 删除指定的参数
          params.delete('login');
          // 构造新的URL
          const newUrl = `${window.location.pathname}?${params.toString()}${
            window.location.hash
          }`;
          window.history.replaceState({}, '', newUrl);
          location.reload();
        }
      });
    },
    closeBindInfo() {
      this.$store.commit('changeLoginShow', false);
      let params = this.loginParams;
      params.confirm = 1;
      Toast('之后可以在「我的」-「设置」绑定游戏信息');
      this.$parent.webUserLogin(params);
    },
    getBind() {
      if (this.bindNum != '') {
        let params = this.loginParams;
        params.bindCode = this.bindNum;
        get.useBindCode(qs.stringify(params)).then((res) => {
          console.log(res);
          // if (res.data.code == 2055) {
          //   Toast('绑定码不存在或错误');
          // } else if (res.data.code == 2056) {
          //   Toast('该绑定码已经绑定，不能二次绑定');
          // } else
          if (res.data.code != 0) {
            this.errorMessage(res.data);
          } else if (res.data.data.length != 0) {
            //绑定登录成功
            let objToken = JSON.parse(sessionStorage.getItem('userObj'));
            objToken.token = res.data.data[0].token;
            objToken.loginStatus = true;
            sessionStorage.setItem('userObj', JSON.stringify(objToken));
            this.$store.commit(
              'setUserInfo',
              JSON.parse(sessionStorage.getItem('userObj'))
            );
            this.$store.commit('changeToken', objToken.token);
            this.$store.commit('changeLoginStatus', 1);
            this.tipNum = null;
            this.pageIndex = null;
            this.$store.commit('changeLoginShow', false);
            this.$store.commit('changeBindCodeShow', false);
          }
        });
      } else {
        // this.getTip(3, 3);
        Toast('绑定码不存在或错误');
      }
    },
    confirmAcc() {
      if (this.selectOnAcc.token) {
        let objToken = JSON.parse(sessionStorage.getItem('userObj'));
        objToken.token = this.selectOnAcc.token;
        objToken.loginStatus = true;
        objToken.memberId = this.selectOnAcc.memberId;
        sessionStorage.setItem('userObj', JSON.stringify(objToken));
        this.$store.commit(
          'setUserInfo',
          JSON.parse(sessionStorage.getItem('userObj'))
        );
        this.$store.commit('changeToken', objToken.token);
        this.$store.commit('changeLoginStatus', 1);
        this.$store.commit('changeLoginShow', false);
        if (
          this.selectOnAcc.bindFlag == 1 &&
          this.$store.state.gameType == 2
          // window.user.appkey == 1705460260139
        ) {
          this.$store.commit('changeBindCodeShow', true);
        } else {
          if (
            this.$store.state.gameType == 2
            // window.user.appkey == 1705460260139
          ) {
            this.$store.commit('changeBindCodeShow', false);
          }
        }
        let gameAppkey =
          this.$store.state.gameAppkeyArr[this.$store.state.gameType];
        Cookies.set(`_pd_dvid_${gameAppkey}`, this.selectOnAcc.dvid, {
          expires: 14,
          path: '/',
          domain: '.tentree-games.com'
        });
        Cookies.set(`_pd_auth_${gameAppkey}`, this.selectOnAcc.token, {
          expires: 14,
          path: '/',
          domain: '.tentree-games.com'
        });
        let _pd_bf = Cookies.get('_pd_bf').split('##');
        let _pd_bf_index = _pd_bf.findIndex((item) =>
          item.includes(this.selectOnAcc.memberId)
        );
        Cookies.set('_pd_bf', _pd_bf[_pd_bf_index], {
          expires: 14,
          path: '/',
          domain: '.tentree-games.com'
        });
      } else {
        Toast('请选择要登录的账号');
      }
    },
    chooseAccount(item) {
      this.selectOnAcc = item;
    },
    getTip(index, num) {
      this.pageIndex = index;
      this.tipNum = num;
    },
    login() {
      if (this.isAgree) {
        let phoneReg = /^1[3-9]\d{9}$/;
        if (phoneReg.test(this.form.account)) {
          if (this.code != '' && !this.loading) {
            this.loading = true;
            let params = {
              // appkey: window.user.appkey,
              appkey:
                this.$store.state.gameAppkeyArr[this.$store.state.gameType],
              device: this.$store.state.isPad
                ? `snsweb${this.getRamNumber()}`
                : `snswechat${this.getRamNumber()}`,
              code: this.code,
              account: this.form.account,
              action: 'access',
              channel: '2010011001',
              ecid: '3010081001',
              version: 'v2',
              tag: 1
            };
            get.phoneLogin(params).then((res) => {
              if (res.data.status == 1) {
                let info = res.data.data;
                let params = {
                  token: info.token,
                  userId: info.userid,
                  device: this.$store.state.isPad
                    ? `snsweb${this.getRamNumber()}`
                    : `snswechat${this.getRamNumber()}`
                };
                this.loginParams = params;
                this.$parent.webUserLogin(params);
              } else {
                // this.getTip(3, 2);
                Toast('验证码错误');
                this.loading = false;
              }
            });
          } else {
            this.tipNum = 2;
            this.pageIndex = 3;
          }
        } else {
          // this.pageIndex = 3;
          // this.tipNum = 1;
          Toast('手机号格式错误');
        }
      } else {
        this.$refs.agree.className = 'bottom-agree agree-ani';
        setTimeout(() => {
          this.$refs.agree.className = 'bottom-agree';
        }, 500);
      }
    },
    closeTip() {
      switch (this.tipNum) {
        case 0:
          this.tipNum = null;
          this.pageIndex = null;
          this.$store.commit('changeLoginShow', false);
          break;
        case 1:
          this.form.account = '';
          this.tipNum = null;
          this.pageIndex = 0;
          break;
        case 2:
          this.code = '';
          this.tipNum = null;
          this.pageIndex = 0;
          break;
        case 3:
          this.bindNum = '';
          this.tipNum = null;
          this.pageIndex = 1;
          break;
        case 4:
          this.bindNum = '';
          this.tipNum = null;
          this.pageIndex = 1;
          break;
      }
    },
    sendMessage() {
      if (this.form.account == '') {
        Toast('请输入手机号');
      } else {
        let phoneReg = /^1[3-9]\d{9}$/;
        if (phoneReg.test(this.form.account)) {
          this.form.sign = this.$md5(
            this.$md5(this.form.account + 'ACED000574') + 'ACED000574'
          );
          this.waitTime = 60;
          let timer1 = setInterval(() => {
            this.waitTime--;
            if (this.waitTime == 0) {
              clearInterval(timer1);
            }
          }, 1000);
          let c = penc.ps(this.form);
          // c.h.appkey = window.user.appkey;
          (c.h.appkey =
            this.$store.state.gameAppkeyArr[this.$store.state.gameType]),
            get.sendCode({ d: c.d }, c.h).then((res) => {
              // console.log(res.headers['zl-ret-nonce']);
              // console.log(res.headers['zl-ret-sign']);
              // console.log(res.config.headers['zl-p-nonce']);
              let b = {
                'zl-ret-nonce': res.headers['zl-ret-nonce'],
                'zl-ret-sign': res.headers['zl-ret-sign'],
                getResponseHeader: function (a) {
                  return b[a];
                }
              };
              let dataInfo = penc.de(
                res.data.ret,
                b,
                res.config.headers['zl-p-nonce']
              );
              console.log(dataInfo);
              if (dataInfo.status == 1) {
                //发送成功
              }
            });
        } else {
          // this.pageIndex = 3;
          // this.tipNum = 1;
          Toast('手机号格式错误');
        }
      }
    },
    getRamNumber() {
      var result = '';
      for (var i = 0; i < 40; i++) {
        result += Math.floor(Math.random() * 16).toString(16); //获取0-15并通过toString转16进制
      }
      return result;
    },
    back() {
      this.$store.commit('changeLoginShow', false);
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  },
  created() {},
  mounted() {
    let height = document.body.clientHeight;
    let userAgent = navigator.userAgent;
    let isAndroid =
      userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    if (isAndroid) {
      window.addEventListener('resize', () => {
        if (document.body.clientHeight < height) {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.xcx .login-mo .bottom-agree {
  bottom: 1.2rem !important;
}

.login-conatiner {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  i {
    font-style: normal;
  }

  .login-mo {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    i {
      font-style: normal;
    }

    .logo {
      width: 2.6rem;
      height: 1.23rem;
      background: url('../assets/img/gl/login-logo.png');
      background-size: 100% 100%;
      margin-top: 2.24rem;
      margin-bottom: 3.8rem;
    }

    .input-box {
      width: 6.29rem;
      height: 0.72rem;
      border: 0.01rem solid #b3b3b3;
      display: flex;
      align-items: center;

      .phone-num {
        width: 0.9rem;
        height: 0.4rem;
        border-right: 0.01rem solid #969696;
        color: #1a1a1a;
        font-size: 0.28rem;
        font-style: normal;
        text-align: center;
        line-height: 0.4rem;
        margin-right: 0.2rem;
      }

      input {
        font-size: 0.28rem;
        width: 100%;
        height: 0.4rem;
        border: none;
        outline: none;
      }

      *::-webkit-input-placeholder {
        color: #cccccc;
      }

      *:-moz-placeholder {
        /* FF 4-18 */
        color: #cccccc;
      }

      *::-moz-placeholder {
        /* FF 19+ */
        color: #cccccc;
      }

      *:-ms-input-placeholder {
        /* IE 10+ */
        color: #cccccc;
      }
    }

    .input-box1 {
      margin-top: 0.39rem;
      margin-bottom: 0.29rem;
    }

    .input-box2 input {
      margin-left: 0.2rem;
    }

    .input-box2 span {
      font-size: 0.22rem;
      margin-right: 0.21rem;
      white-space: nowrap;
    }

    span {
      color: #23323d;
      font-size: 0.24rem;
    }

    .login-btn {
      width: 6.29rem;
      height: 0.72rem;
      background: #23323d;
      text-align: center;
      line-height: 0.72rem;
      font-size: 0.32rem;
      color: #fff;
      font-style: normal;
      margin-top: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: #fff;
      }
      .loading {
        display: block;
        width: 0.4rem;
        height: 0.4rem;
        background: url('../assets/img/login_loading.png');
        background-size: 100% 100%;
        animation: loadingAni 1s infinite linear;
      }
      @keyframes loadingAni {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }

    @keyframes agreeAni {
      0% {
        transform: translateX(0);
      }

      25% {
        transform: translateX(0.2rem);
      }

      50% {
        transform: translateX(0);
      }

      75% {
        transform: translateX(-0.2rem);
      }

      100% {
        transform: translateX(0rem);
      }
    }

    .agree-ani {
      animation: agreeAni 200ms 2 linear;
    }

    .bottom-agree {
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      margin-top: 1rem;
      // position: absolute;
      // bottom: 2.76rem;

      .select-icon {
        width: 0.27rem;
        height: 0.27rem;
        background: url('../assets/img/gl/select-icon.png');
        background-size: 100% 100%;
        margin-right: 0.12rem;
      }

      .select-on {
        width: 0.27rem;
        height: 0.27rem;
        background: url('../assets/img/gl/select-on.png');
        background-size: 100% 100%;
        margin-right: 0.12rem;
      }
    }

    .pop {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 0.3rem;
        font-weight: 500;
        color: #2b2b2b;
      }

      .close {
        width: 0.28rem;
        height: 0.25rem;
        background: url('../assets/img/gl/close.png');
        background-size: 100% 100%;
        position: absolute;
        right: 0.3rem;
        top: 0.24rem;
      }

      .choose-box {
        width: 5.6rem;
        height: 4.63rem;
        background: #ffffff;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          margin: 0.3rem 0;
          margin-bottom: 0.2rem;
        }

        .tip {
          font-weight: 400;
          color: #b3b3b3;
          font-size: 0.22rem;
        }

        .user-box {
          width: 3.8rem;
          height: 1.99rem;
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          margin-bottom: 0.3rem;

          .user {
            width: 1.58rem;
            height: 1.99rem;
            border: 1px solid #e6e6e6;
            display: flex;
            flex-direction: column;
            align-items: center;

            .avatar {
              display: block;
              width: 1rem;
              height: 1rem;
              border-radius: 50%;
              margin-top: 0.26rem;
              margin-bottom: 0.31rem;
            }

            .name {
              width: 90%;
              font-size: 0.2rem;
              color: #4d4d4d;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: center;
            }
          }

          .user-on {
            border: 1px solid #23303b;
          }
        }

        .choose-btn {
          font-style: normal;
          width: 2rem;
          height: 0.72rem;
          background: #23303b;
          text-align: center;
          line-height: 0.71rem;
          color: #fff;
        }
      }

      .game-info {
        width: 5rem;
        height: 4.55rem;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        // align-items: center;
        padding: 0 0.3rem;
        box-sizing: border-box;
        position: relative;

        .title {
          margin-top: 0.3rem;
          margin-bottom: 0.2rem;
          text-align: center;
        }

        .tip {
          font-size: 0.22rem;
          color: #1a1a1a;
        }

        .tip-2 {
          display: flex;
          align-items: center;
          margin-top: 0.1rem;
          margin-bottom: 0.1rem;

          span {
            color: #808492;
            font-size: 0.2rem;
            margin-right: 0.15rem;
            white-space: nowrap;
          }

          .help-icon {
            width: 0.21rem;
            height: 0.22rem;
            background: url('../assets/img/gl/help-icon.png');
            background-size: 100% 100%;
          }
        }

        input {
          width: 4.38rem;
          height: 0.72rem;
          border: 0.01rem solid #b3b3b3;
          padding-left: 0.21rem;
          box-sizing: border-box;
          margin-top: 0.1rem;
        }

        *::-webkit-input-placeholder {
          color: #cccccc;
        }

        *:-moz-placeholder {
          /* FF 4-18 */
          color: #cccccc;
        }

        *::-moz-placeholder {
          /* FF 19+ */
          color: #cccccc;
        }

        *:-ms-input-placeholder {
          /* IE 10+ */
          color: #cccccc;
        }

        .submit-game {
          color: #fff;
          width: 4.38rem;
          height: 0.72rem;
          background: #23303b;
          text-align: center;
          line-height: 0.72rem;
          margin-bottom: 0.2rem;
          margin-top: 0.2rem;
        }

        .bottom-tip {
          font-size: 0.26rem;
          color: #23303b;
          text-align: center;
        }
      }

      .tip-model {
        width: 5rem;
        height: 3.06rem;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        padding: 0 0.32rem;
        box-sizing: border-box;

        .title {
          margin: 0.3rem 0;
        }

        .tip {
          font-size: 0.22rem;
          color: #1a1a1a;
        }

        .close-tip {
          width: 2rem;
          height: 0.72rem;
          background: #23303b;
          text-align: center;
          line-height: 0.72rem;
          color: #fff;
          position: absolute;
          bottom: 0.3rem;
          cursor: pointer;
        }
      }
    }
  }

  .login-content {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;

    .close {
      width: 0.28rem;
      height: 0.25rem;
      background: url('../assets/img/gl/close.png');
      background-size: 100% 100%;
      position: absolute;
      right: 0.3rem;
      top: 0.24rem;
      cursor: pointer;
    }

    .title {
      color: #2b2b2b;
      font-size: 0.3rem;
    }

    .phone-login {
      width: 7.11rem;
      height: 5.08rem;
      background-color: #fff;
      position: relative;
      padding: 0 0.41rem;
      padding-top: 0.31rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .title {
        color: #2b2b2b;
        font-size: 0.3rem;
        font-weight: 500;
      }

      .tip {
        color: #969696;
        font-size: 0.24rem;
        font-weight: 400;
        margin-top: 0.18rem;
        margin-bottom: 0.2rem;
      }

      .input-box {
        width: 6.29rem;
        height: 0.72rem;
        border: 0.01rem solid #969696;
        display: flex;
        align-items: center;
      }

      *::-webkit-input-placeholder {
        color: #cccccc;
      }

      *:-moz-placeholder {
        /* FF 4-18 */
        color: #cccccc;
      }

      *::-moz-placeholder {
        /* FF 19+ */
        color: #cccccc;
      }

      *:-ms-input-placeholder {
        /* IE 10+ */
        color: #cccccc;
      }

      .input-box input {
        border: none;
        outline: none;
      }

      .input-box1 .phone-num {
        width: 0.98rem;
        height: 0.4rem;
        border-right: 0.01rem solid #969696;
        color: #1a1a1a;
        font-size: 0.28rem;
        font-style: normal;
        text-align: center;
        line-height: 0.4rem;
        margin-right: 0.19rem;
      }

      .input-box1 input {
        font-size: 0.28rem;
        width: 100%;
        height: 0.4rem;
      }

      .input-box2 {
        margin-top: 0.29rem;
        margin-bottom: 0.36rem;

        span {
          font-size: 0.22rem;
          color: #23323d;
          margin-right: 0.21rem;
          white-space: nowrap;
        }

        input {
          font-size: 0.28rem;
          color: #23323d;
          height: 0.4rem;
          width: 100%;
          margin-left: 0.18rem;
        }
      }

      .login-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        font-style: normal;
        margin-bottom: 0.26rem;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          color: #fff;
        }
        .loading {
          display: inline-block;
          width: 0.4rem;
          height: 0.4rem;
          background: url('../assets/img/login_loading.png');
          background-size: 100% 100%;
          animation: loadingAni 1s infinite linear;
        }
        @keyframes loadingAni {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }

      @keyframes agreeAni {
        0% {
          transform: translateX(0);
        }

        25% {
          transform: translateX(0.2rem);
        }

        50% {
          transform: translateX(0);
        }

        75% {
          transform: translateX(-0.2rem);
        }

        100% {
          transform: translateX(0rem);
        }
      }

      .agree-ani {
        animation: agreeAni 200ms 2 linear;
      }

      .bottom-agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.24rem;

        // transform: translateX(14%);
        .select-icon {
          width: 0.24rem;
          height: 0.24rem;
          background: url('../assets/img/gl/select-icon.png');
          background-size: 100% 100%;
          margin-right: 0.12rem;
        }

        .select-on {
          width: 0.24rem;
          height: 0.24rem;
          background: url('../assets/img/gl/select-on.png');
          background-size: 100% 100%;
          margin-right: 0.12rem;
        }
      }
    }

    .game-info {
      width: 5.51rem;
      height: 4.47rem;
      background: #ffffff;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0.34rem;
      box-sizing: border-box;

      .title {
        color: #2b2b2b;
        font-size: 0.3rem;
        margin-top: 0.28rem;
        margin-bottom: 0.17rem;
      }

      .tip {
        color: #1a1a1a;
        font-size: 0.24rem;
      }

      .tip-2 {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 0.1rem;
        margin-bottom: 0.16rem;

        span {
          font-size: 0.24rem;
          color: #808492;
          margin-right: 0.09rem;
        }

        .help-icon {
          width: 0.22rem;
          height: 0.22rem;
          background: url('../assets/img/gl/help-icon.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
      }

      input {
        width: 4.88rem;
        height: 0.72rem;
        border: 0.01rem solid #b3b3b3;
        outline: none;
        font-size: 0.28rem;
        padding-left: 0.23rem;
        box-sizing: border-box;
      }

      .submit-game {
        font-style: normal;
        text-align: center;
        line-height: 0.72rem;
        width: 4.88rem;
        height: 0.72rem;
        background: #23303b;
        color: #fff;
        font-size: 0.26rem;
        margin-top: 0.2rem;
        margin-bottom: 0.24rem;
      }

      .bottom-tip {
        color: #23303b;
        font-size: 0.2rem;
      }
    }

    .choose-box {
      width: 5.6rem;
      height: 4.63rem;
      background: #ffffff;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;

      .title {
        margin-top: 0.3rem;
        margin-bottom: 0.27rem;
      }

      .tip {
        color: #b3b3b3;
        font-size: 0.24rem;
      }

      .user-box {
        width: 3.8rem;
        height: 1.99rem;
        display: flex;
        justify-content: space-between;
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;

        .user {
          width: 1.58rem;
          height: 1.99rem;
          border: 1px solid #e6e6e6;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .user-on {
          border: 1px solid #23303b;
        }

        .avatar {
          background-color: #1c93fe;
          display: block;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin-top: 0.26rem;
          margin-bottom: 0.31rem;
        }

        .name {
          width: 90%;
          font-size: 0.2rem;
          color: #4d4d4d;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
        }
      }

      .choose-btn {
        font-style: normal;
        width: 2rem;
        height: 0.72rem;
        background: #23303b;
        text-align: center;
        line-height: 0.71rem;
        color: #fff;
      }
    }

    .tip-model {
      width: 5.35rem;
      height: 3.06rem;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0.3rem;
      box-sizing: border-box;
      position: relative;
      font-size: 0.24rem;

      .title {
        margin-top: 0.3rem;
        margin-bottom: 0.27rem;
        color: #2b2b2b;
        font-size: 0.3rem;
      }

      span {
        color: #1a1a1a;
        font-size: 0.24rem;
        text-align: center;
      }

      .close-tip {
        width: 2rem;
        height: 0.72rem;
        background: #23303b;
        text-align: center;
        line-height: 0.72rem;
        color: #fff;
        position: absolute;
        bottom: 0.3rem;
        cursor: pointer;
      }
    }
  }
}

.login-conatiner-back {
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
}
</style>